// Singleton Stores
import {default as _Aggregate} from './aggregate';
import {default as _App} from './app';

export const AggregateStore = new _Aggregate();
export const AppStore = new _App();



// WEBPACK FOOTER //
// ./src/js/stores/index.js